
/**
 * Utility functions for handling redirects to the application domain
 */

export const APP_DOMAIN = "app.upfixe.com";

/**
 * Returns the full URL to the app domain with the specified path
 */
export const getAppUrl = (path: string = ""): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;
  return `https://${APP_DOMAIN}${cleanPath ? `/${cleanPath}` : ""}`;
};

/**
 * Returns the app URL for authentication
 * Always returns the base app URL without any parameters
 */
export const getAuthUrl = (): string => {
  return `https://${APP_DOMAIN}`;
};

/**
 * Checks if the current path is an auth-related path that should redirect to the app domain
 */
export const shouldRedirectToApp = (path: string): boolean => {
  const authPaths = [
    "/auth", 
    "/dashboard", 
    "/brands", 
    "/campaigns", 
    "/reporting", 
    "/settings",
    "/login",
    "/signup",
    "/signin",
    "/register"
  ];
  
  return authPaths.some(authPath => path.startsWith(authPath));
};
